export default __webpack_public_path__ + "static/media/infoVideoPreview.3d7249f3.jpg";